<div class="wrapper">
  <div class="container">
    <div class="inline-icon" inlineSVG="sot/sot-icon.svg#sot-HypersoftLogo"></div>
  </div>
  <div class="container">
    <div class="text-container">
      <p>
        Starte Hypersoft SOT
      </p>
      <p>
        {{initalisation_status}}
      </p>
      <div class="loader">
        <div class="loader-wrapper">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="version">
        <p>
          Version: {{version}}
        </p>
      </div>
    </div>
  </div>
</div>